// extracted by mini-css-extract-plugin
module.exports = {"Start":"StartStudying-module--Start--36aR9"};